import { OctAutocomplete } from '@oceantech/oceantech-ui'
import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { localStorageItem } from '../../utils/LocalStorage'
import { KEY_LOCALSTORAGE } from '../../auth/core/_consts'
import { getListKhoaPhong } from '../../utils/ServicesUtils'
import { LEVEL } from '../../utils/Constant'

type Props = {
    typeRoom: number
    handleClose: () => void
}

const PrePendingPopup = ({ typeRoom, handleClose }: Props) => {
    const [phongSelected, setPhongSelected] = React.useState<any>(null);

    const handleOpenPendingScreen = () => {
        const w = window.screen.availWidth;
        const h = window.screen.availHeight;

        const url = `${window.location.origin}/pending`;

        window.open(
            url,
            "_blank",
            `toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=${w},height=${h},top=0,left=0`
        );
        handleClose();
    };
    
    useEffect(() => {
        if (phongSelected) {
            localStorageItem.set(KEY_LOCALSTORAGE.ROOM_FOR_PENDING_SCREEN, phongSelected);
            handleOpenPendingScreen();
        }
    }, [phongSelected]);

    return (
        <Modal
            show={true}
            onHide={handleClose}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Chọn khoa phòng
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <OctAutocomplete
                        options={[]}
                        placeholder="Tất cả khoa phòng"
                        menuPlacement="bottom"
                        searchFunction={getListKhoaPhong}
                        searchObject={{
                            level: LEVEL.PHONG,
                            type: typeRoom,
                        }}
                        onChange={option => {
                           setPhongSelected(option)
                        }}
                        menuPortalTarget={document.getElementById("root")}
                        styles={{
                            menuPortal: (styles: any) => ({
                                ...styles,
                                zIndex: 135790,
                              })
                        }}
                    />
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default PrePendingPopup